module.exports = __webpack_public_path__ + "img/ola-logo.50674d8e.png";